<template>
  <ScModal
    :show="show"
    :class="'change-phone-number-modal'"
    @close="close"
  >
    <form
      v-if="show"
      novalidate
      @submit.prevent="onSubmit"
    >
      <div class="modal-header">
        <button
          type="button"
          class="close"
          @click="close"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="message-wrapper">
          <img
            src="https://cdn.dsmcdn.com/seller-center/account/images/message-popup.svg"
            alt="message"
          >
          <span>
            Sizinle doğru iletişim kurabilmemiz için telefon numaranızın güncel ve doğrulanmış olması gerekmektedir.
          </span><br>
          <small class="g-text-light-grey-100">
            Telefon numaranızı güncelleyip aşağıdaki butona tıklayarak kolayca doğrulayabilirsiniz.
          </small>
        </div>
        <div
          class="form-input"
          v-for="(input, index) in modalData"
          :key="'form-input-'+index"
        >
          <ScLabel>
            {{ $t(`authorization.inputs.label.${input.key}`) }}
          </ScLabel>
          <PhoneNumber
            :ref="input.key"
            :class="{invalid: errors.has(input.key)}"
            v-validate="input.validation"
            :data-vv-name="input.key"
            v-model="input.value"
            :placeholder="$t(`authorization.inputs.placeholder.${input.placeholder}`)"
            mask="0599 999 99 99"
          />
          <span class="error-message">
            {{ errors.first(input.key) }}
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <InvisibleRecaptcha
          @callback="onCaptcha"
          :validate="onValidate"
          class="btn btn-lg btn-mp-primary btn-block"
          type="submit"
          :site-key="siteKey"
        >
          {{ $t('authorization.modal.changePhoneNumberButton') }}
        </InvisibleRecaptcha>
      </div>
    </form>
  </ScModal>
</template>

<script>

import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import ScModal from '@trendyol/sc-ui-kit/ScModal';
import RecaptchaService from '@/services/RecaptchaService';
import InvisibleRecaptcha from '@/components/Shared/InvisibleRecaptcha';
import PhoneNumber from '@/components/Shared/PhoneNumber';
export default {
  name: 'ChangePhoneNumberModal',
  components: { PhoneNumber, ScLabel, ScModal, InvisibleRecaptcha },
  data () {
    return {
      siteKey: RecaptchaService.getInvisibleSiteKey(),
      isInitial: true,
      modalData: [
        {
          key: 'myPhone',
          placeholder: 'phoneNumber',
          value: '',
          validation: {
            required: this.$t(`authorization.inputs.placeholder.phone`),
            phoneNumber: 11,
          },
        },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show () {
      this.isInitial = true;
      this.modalData.map((val, index) => {
        this.$set(this.modalData[index], 'value', '');
      });
    },
  },
  methods: {
    close () {
      this.errors.clear();
      this.$emit('close');
    },
    onValidate () {
      return this.$validator.validate();
    },
    onCaptcha (captchaPayload) {
      this.$emit('submit', captchaPayload, {
        phoneNumber: this.modalData[0].value.toString().replace(/[^\d]/g, ''),
      });
    },
    onSubmit () {

    },
  },
};
</script>

<style lang="scss" scoped>
  .change-phone-number-modal{
    & .modal-header{
      padding: 35px 30px 25px 30px;
      & .modal-title{
        font-size: 20px !important;
      }
    }
    & .modal-body{
      padding: 0 30px;

      .message-wrapper {
        margin-bottom: 30px;
        color: #273142;
        font-weight: 500;
        text-align: center;
        font-size: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;

        img {
          margin-bottom: 30px;
        }
      }

      & .form-input {
        position: relative;
        &:not(:first-child) {
          margin-top: 20px;
        }
        &::v-deep input{
          height: 40px;
        }
        & .invalid{
          &::v-deep input{
            border-color: #dc3545;
          }
          &::v-deep .eye-icon:before{
            color: #dc3545;
          }
        }
      }
      .error-message {
        position: absolute;
        color: #dc3545;
      }
    }

    & .modal-footer{
      padding: 30px;
      border-top: none;
      & .form-button {
        width: 100%;
        height: 40px;
      }
    }
  }
</style>
